import { render, staticRenderFns } from "./CostTask.vue?vue&type=template&id=53853525&"
import script from "./CostTask.vue?vue&type=script&lang=js&"
export * from "./CostTask.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports